//AUTH
export const API_REGISTER = "auth/register";
export const API_LOGIN = "auth/login";
export const API_FORGOT_PASSWORD = "auth/password/email";
export const API_VERIFY_OTP = "auth/otp_verify";
export const API_RESEND_OTP = "auth/resend_otp";
export const API_LOGOUT = "auth/logout";

export const API_REFRESH_TOKEN = "auth/refresh";

//PROFILE
export const API_PROFILE = "profile/profile";
export const API_GET_INVESTMENT_AMOUNT = "profile/checkInvestmentAmount";
export const API_GET_USER_INVESTMENT = "profile/userInvestment";
export const API_GET_INVESTMENT_PORTFOLIO = "profile/userInvestmentPortfolio";
export const API_GET_INVESTMENT_SEARCHGROUP =
  "profile/userinvestmentSearchGroup";
export const API_GET_WITHDRAWALS = "profile/UserWithdrawals";
export const API_WITHDRAWAL_REQUEST = "profile/withdrawalRequest";

export const API_CONVERT_TO_CYCLE = "investment/_product/convertToCycle/";
export const API_GET_OPPORTUNITIES = "investment/_product";
export const API_GET_OPPORTUNITY_DETAILS = "investment/_product/{id}";

export const API_UPDATE_PASSWORD = "update-password";
export const API_VERIFY = "auth/verify-email?userId={:id}&token={:token}";
export const API_GOOGLE_LOGIN = "auth/login/google";
export const API_GOOGLE_REGISTER = "auth/register/google";
export const API_RESEND_VERIFICATION = "auth/resend-token";
export const API_GET_USERS = "user";
export const API_LOGIN_PIN = "login-pin";
export const API_RESET_PIN = "customer/reset-pin";

export const API_RESET_PASSWORD = "auth/reset-password";

export const API_CREATE_PROFILE = "user/profile";

export const API_NOTIFICATION = "notification";
export const API_MARK_NOTIFICATION_AS_READ = "notification/mark-as-read";
export const API_DELETE_ALL_NOTIFICATION = "notification";
export const API_GET_READ_NOTIFICATIONS = "notification/read";
export const API_GET_UNREAD_NOTIFICATION = "notification/unread";

export const API_FUND_WALLET = "wallet/fundWallet";
export const GET_WALLET_BALANCE = "wallet/myWallet";
export const API_ADD_BANK_DETAILS = "profile/bank";
export const API_GET_BANK_NAMES = "profile/bank";
export const API_GET_BANKS = "all-banks";
export const API_GET_USER_NGR_BANKS =
  "Management/user/user-bank-accounts?user_id=";
export const API_GET_USER_USD_BANKS =
  "Management/user/user-dollar-accounts?user_id=";
export const API_GET_ACCOUNT_NAME = "verify-bank-account";
export const API_WITHDRAW_FUNDS = "Management/user/initiateWithdrawal";
export const API_GET_USER_BANK = "profile/bank";
export const API_REMOVE_BANK = "profile/bank";

export const API_UPDATE_USER_PROFILE = "profile/profile";
export const API_GET_USER_PROFILE = "profile/profile";

export const API_UPDATE_BVN = "profile/update-bvn";

export const API_GET_ALL_PACKAGES = "Management/subscription/packages";
export const API_RECORD_JOURNAL = "acct/record?stage=";
export const API_VERIFY_DOCUMENT =
  "Management/user/verifyUserDocument?user_id=";
export const API_USER_ROLES = "Management/user/role";
export const API_ASSIGN_USER_INTERNAL =
  "Management/user/internalStatus?user_id=";
export const API_ASSIGN_USER_ROLE = "Management/user/assign-role?user_id=";
export const API_REMOVE_USER_ROLE = "Management/user/remove-role?user_id=";

export const API_SUBSCRIBE_PACKAGE = "payment/start?subscriptionPackageId=";

// SUBSCRIPTION
export const API_CREATE_SUBSCRIPTION = "Management/subscription/packages";
export const API_GET_SUBSCRIPTION_BY_CURRENCY =
  "Management/user/subscription/packages/USD";

//INVESTMENT
export const API_CREATE_CATEGORY_INVESTMENT = "investment/_category";
export const API_UPDATE_CATEGORY_INVESTMENT = "investment/_category/";
export const API_GET_ALL_CATEGORY_INVESTMENT = "investment/_category";
export const API_GET_CATEGORY_BY_DETAIL = "investment/_category/";

export const API_INVESTMENT_TO_BUSINESS = "investment/_product/addbusiness/";
export const API_CREATE_PRODUCT_TIMELINE = "investment/add_timeline";
export const API_EDIT_PRODUCT_TIMELINE =
  "investment/update-investment-timeline/";
export const API_CREATE_PRODUCT_INVESTMENT = "investment/_product";
export const API_REAL_ESTATE_PRODUCT_INVESTMENT = "investment/_property";
export const API_UPDATE_PRODUCT_INVESTMENT = "investment/_product/";
export const API_DELETE_PRODUCT_INVESTMENT = "investment/_collection/";
export const API_DELETE_REAL_ESTATE_INVESTMENT = "investment/_property/";
export const API_CLOSE_OUT_INVESTMENT = "investment/close-investments/";
export const API_CLOSE_OUT_PROPERTY = "investment/close-property-investments/";
export const API_UPDATE_USER_INVESTMENT = "investment/updateUserInvestment/";
export const API_GET_ALL_PRODUCT_INVESTMENT = "investment/_product";
export const API_GET_PRODUCT_BY_DETAIL = "investment/_product/";
export const API_GET_PRODUCT_INTEREST = "product/showInterestsByCycle/";
export const API_GET_REALESTATE_INTEREST = "product/showInterestsByProduct/";

export const API_GET_BUSINESSES = "investment/businesses/ALL?type=2";
export const API_CREATE_BUSINESS_PRODUCTS = "investment/_collection";
export const API_EDIT_BUSINESS_PRODUCTS = "investment/_collection/";
export const API_GET_BUSINESSES_PRODUCTS = "investment/currency?business_id=";

export const API_CREATE_BUSINESSES = "investment/businesses";
export const API_GET_INVESTMENT_METRIC = "investment/investmentMetrics";

export const API_GET_INVESTMENT_METRIC_BY_CURRENCY =
  "investment/investmentMetricsByCurrency?currency=";
export const API_GET_TRANSACTION_METRIC_BY_CURRENCY =
  "investment/transactionMetricsByCurrency?currency=";
export const API_GET_PRODUCT_INTERESTS = "product/_interest";
export const API_GET_PAYMENT_SCHEDULES = "investment/payout";
export const API_GET_PAYOUT_HISTORY = "investment/payout_history";
export const API_GET_REAL_ESTATE_PAYOUT_HISTORY = "investment/payout/product/";
// Payouts scoped to a single cycle (campaign) - preferred over the product
// endpoint, which returns every cycle of the product.
export const API_GET_CYCLE_PAYOUT_HISTORY = (cycleId) =>
  `investment/payout/cycle/${cycleId}`;
export const API_INVESTMENT_TIMELINE = "investment/all-timelines";
export const API_DELETE_INVESTMENT_TIMELINE = "investment/deleteTimeline/";
export const API_TIMELINE = "investment/timeline/";
export const API_TOGGLE_INVESTMENT = "investment/_product/status/";
export const API_TOGGLE_STATUS_INVESTMENT = "investment/_product/status/";
export const API_TOGGLE_REAL_ESTATE_STATUS = "investment/_property/";
export const API_GET_PRODUCT_INVESTMENT_BY_CURRENCY = "investment/currency/";
export const API_GET_INVESTMENT_BY_INVESTOR =
  "investment/get-investor-by-investment-product-all/";
export const API_MOVE_INVESTMENT_UP =
  "investment/_product/move-up?investment_product_id=";
export const API_MOVE_INVESTMENT_DOWN =
  "investment/_product/move-down?investment_product_id=";
export const API_REODER_INVESTMENT = "investment/_product/re-order";

//user
export const API_GET_USER_METRICS = "Management/user/userMetrics";
export const API_GET_WAITING_USERS = "Management/user/waitingUsers";
export const API_GET_BIP_USERS = "Management/user/subscribers";
export const API_GET_BUSINESS_USERS = "admin/getUsers";
export const API_GET_ALL_USER = "Management/user/users";
export const API_SEARCH_USER = "Management/user/search?searchTerm=";
export const API_GET_USER_DETAIL = "Management/user/users/";
export const API_GET_BUSINESS_USER_DETAIL = "admin/getUsers/";
export const API_GET_UPDATE_USER = "Management/user/users/";
export const API_DELETE_USER = "Management/user/destroyForce/";
export const API_DOWNLOAD_USER_ON_MOBILE =
  "investment/mobile-login-statistics/export";
export const API_RESET_USER_PASSCODE = "Management/user/reset-passcode/";
export const API_RESET_USER_TRANSACTION_PIN =
  "Management/user/resetPin?user_id=";
export const API_GET_RESTORE_USER = "Management/user/restoreUser/";
export const API_GET_RESTORE_ALL_USERS = "Management/user/restoreAllUsers";
export const API_GET_RETRIEVE_ALL_TRASHED_USERS =
  "Management/user/retrieveAllTrashedUsers";
export const API_GET_RETRIEVE_ALL_USER_WITH_THRASHED =
  "Management/user/retrieveAllUsersWithTrashed";
export const API_USER_EMAIL_UPDATE = "Management/user/updateUserEmail/";
export const API_USER_ROLE_ASSIGN = "Management/user/assignRoleToUser";
export const API_GET_USER_SUBSCRIPTION_PACKAGE =
  "Management/user/get-user-subscriptions-using-subscription-package/";
export const API_GET_USER_PLAN = "Management/user/freePlan";
export const API_FUND_WALLET_OTP = "wallet/fund-otp?user_id=";
export const API_VERIFY_BVN = "wallet/update-user-bvn";
export const API_FUND_WALLET_CONFIRMATION = "wallet/credit-wallet?user_id=";
export const API_APPROVE_FREE_USER_PLAN =
  "Management/user/approveFreeSubscription?userId=";
export const API_UNLOCK_USER_ACCOUNT = "Management/user/unlock-user";
export const API_SET_MASTER_PASSWORD = "Management/user/setMasterPass?user_id=";
export const API_REMOVE_MASTER_PASSWORD =
  "Management/user/removeMasterPass?user_id=";
export const API_GENERATE_INVESTMENT_STATEMENT =
  "Management/user/generate-investment-statement";
export const API_GENERATE_WALLET_STATEMENT =
  "Management/user/generate-wallet-statement-admin";

//DISBURSEMENT
// export const API_CREATE_DISBURSEMENT = "investment/disburse";
export const API_CREATE_DISBURSEMENT = "investment/manualDisbursement";
export const API_BROADCAST_NOTIFICATION = "auth/send-push/all";
export const API_NOTIFICATION_MULTICAST = "auth/send-push/multicast";
export const API_CREATE_MANUAL_DISBURSEMENT = "investment/disburse-single-user";
export const API_CREATE_PROPORTIONAL__DISBURSEMENT =
  "investment/proportionalDisbursement";
export const API_CREATE_REALESTATE_DISBURSEMENT =
  "investment/disbursePropertyInvestment";
export const API_CREATE_MUDARABAH_DISBURSEMENT =
  "investment/mudarabahDisbursement";
export const API_SUBMIT_BREAK_DOWN =
  "investment/compute-investment-loss-breakdown";
export const API_CLOSE_INDIVIDUAL_INVESTMENTS =
  "investment/close-individual-investments";
export const API_START_INVESTMENT = "investment/start-investment";
export const API_START_RS_INVESTMENT = "investment/start-property-investment/";
export const API_GET_DISBURSEMENT = "investment/getDisburse";
export const API_GET_DISBURSEMENT_LOG = "investment/view-disbursement-log";

export const API_MARK_ADMIN = "Management/user/assignRoleToUser";
export const API_ADD_PREVIOUS_RECORDS = "investment/updatePreviousRecord/";
export const API_ADD_BULK_PREVIOUS_RECORDS =
  "investment/updateBulkPreviousRecord";
export const API_CHANGE_MEMBERSHIP_PLAN =
  "Management/user/approveUserMemberShip/";
export const API_FETCH_USER_TRANSACTIONS =
  "Management/user/userTransactionHistories/";
export const API_FETCH_TRANSACTIONS =
  "transactions/get-total-transaction-by-currency?currency=";

export const API_FETCH_TRANSACTIONS_BY_CURRENCY =
  "transactions/transaction-history-by-currency?currency=";

export const API_FETCH_USER_SUBSCRIPTIONS =
  "Management/user/userSubscriptionHistories/";

export const API_SEND_EMAIL = "Management/user/sendEmail";
export const API_SAVE_TEMPLATE = "Management/template";
export const API_GET_ALL_TEMPLATES = "Management/template";
export const API_DELETE_TEMPLATE = "Management/template";

export const API_FETCH_ALL_WALLET_TO_WALLET =
  "Management/user/conversion-transactions";
// Withdrawal Requests
export const API_FETCH_ALL_WITHDRAWAL_REQUESTS =
  "Management/user/withdrawalRequests";
export const API_FETCH_ALL_DONATION = "admin/hws/donations";
export const API_FETCH_ALL_TICKET_SALES = "admin/hws/subscriptions";
export const API_GET_PAID_WITHDRAWAL_REQUESTS =
  "Management/user/withdrawalRequests/paid";
export const API_GET_PENDING_WITHDRAWAL_REQUESTS =
  "Management/user/withdrawalRequests/pending";
export const API_APPROVE_WITHDRAWAL_REQUESTS =
  "Management/user/approveWithdrawal?currency=";
export const API_CANCEL_WITHDRAWAL_REQUEST =
  "Management/user/cancelWithdrawalRequest?withdrawal_request_id=";

// Transactions
export const API_FETCH_TRANSACTION_BY_CURRENCY = "Wallet/transactionCurrency";
export const API_GET_BUSINESS_TRANSACTION = "admin/credit-transactions";
export const API_GET_APPLICATIONS = "admin/getAll";
export const API_GET_APPLICATION = "admin/get/";
export const API_UPDATE_APPLICATION_STATUS = "admin/credit-status/";

// Settlement
export const API_GET_ALL_SETTLEMENT = "settlement";
export const API_GET_SETTLEMENT_BY_ID = "settlement/user?user_id=";

// Halal Stocks
export const API_HALAL_STOCKS = "Management/halal-stocks?per_page=50";
export const API_GET_HALAL_STOCK = "Management/halal-stocks/"; // + {id}
export const API_HALAL_STOCK_PRICE_HISTORY = (id) =>
  `Management/halal-stocks/${id}/price-history`;
export const API_HALAL_STOCK_ORDERS = (side = "buy") =>
  `Management/halal-stocks/orders/${side}?per_page=50`;
export const API_PLACE_HALAL_STOCK_ORDER_FOR_USER =
  "Management/halal-stocks/orders/place-for-user";
export const API_SELL_HALAL_STOCK_ORDER_FOR_USER =
  "Management/halal-stocks/orders/sell-for-user";
export const API_APPROVE_HALAL_STOCK_ORDER = (id) =>
  `Management/halal-stocks/orders/${id}/approve`;
export const API_REJECT_HALAL_STOCK_ORDER = (id) =>
  `Management/halal-stocks/orders/${id}/reject`;
export const API_UPDATE_HALAL_STOCK_PRICE = (id) =>
  `Management/halal-stocks/${id}/update-price`;
export const API_TOGGLE_HALAL_STOCK_ACTIVE = (id) =>
  `Management/halal-stocks/${id}/toggle-active`;
export const API_DELETE_HALAL_STOCK = (id) => `Management/halal-stocks/${id}`;
export const API_PAY_HALAL_STOCK_DIVIDEND = (id) =>
  `Management/halal-stocks/${id}/dividends`;
export const API_HALAL_STOCK_DIVIDEND_PAYOUTS = (id) =>
  `Management/halal-stocks/${id}/dividend-payouts?per_page=50`;
export const API_HALAL_STOCK_ALL_DIVIDENDS =
  "Management/halal-stocks/dividends/all?per_page=50";
export const API_HALAL_STOCK_INVESTORS = (id) =>
  `Management/halal-stocks/${id}/investors?per_page=50`;
export const API_HALAL_STOCK_BULK_TEMPLATE =
  "Management/halal-stocks/bulk-upload/template";
export const API_HALAL_STOCK_BULK_UPLOAD =
  "Management/halal-stocks/bulk-upload";

// Coop (Providus relay) Transactions
export const API_COOP_TRANSACTIONS = "coop-transactions";
export const API_COOP_TRANSACTIONS_SUMMARY = "coop-transactions/summary";

// Halal Stock IPOs (Management/halal-stock-ipos)
export const API_IPOS = "Management/halal-stock-ipos";
export const API_GET_IPO = (id) => `Management/halal-stock-ipos/${id}`;
export const API_IPO_STATUS = (id) => `Management/halal-stock-ipos/${id}/status`;
export const API_IPO_SUBSCRIPTIONS = (id) =>
  `Management/halal-stock-ipos/${id}/subscriptions`;
export const API_IPO_ALLOT = (id) => `Management/halal-stock-ipos/${id}/allot`;
export const API_IPO_GO_LIVE = (id) =>
  `Management/halal-stock-ipos/${id}/go-live`;
export const API_IPO_REFUND_SUBSCRIPTION = (subscriptionId) =>
  `Management/halal-stock-ipos/subscriptions/${subscriptionId}/refund`;
export const API_IPO_CALCULATE_FOR_USER = (id) =>
  `Management/halal-stock-ipos/${id}/calculate-for-user`;
export const API_IPO_SUBSCRIBE_FOR_USER = (id) =>
  `Management/halal-stock-ipos/${id}/subscribe-for-user`;
